import { render } from "./SettingsApi.vue?vue&type=template&id=6405b04a"
import script from "./SettingsApi.vue?vue&type=script&lang=js"
export * from "./SettingsApi.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__